export default {
  default: {
    abort_changes: 'Abort changes',
    accept: 'I accept',
    accept_terms: 'I confirm that I am of legal age and accept',
    accept_invite: 'Accept invite',
    access_codes: 'Access codes',
    access_edit_profile: 'Edit profile',
    access_event_search: 'Search for events',
    access_participants_count: '{{text}} participants',
    access_participants_count_with_limit: '{{count}} of {{limit}} participants',
    access_press_to_select: 'Double tap to edit {{type}}',
    access_select_sport_level: 'Select {{level}}',
    access_selected_sport_level: 'Your {{sport}} level is {{level}}',
    account_details: 'Details',
    account_screen: 'Account screen',
    account: 'Account',
    address: 'Address',
    add_interests: 'Add Interests',
    admin_panel: 'Admin Panel',
    add_company: 'Add Company',
    add_location: 'Add Location',
    add_module: 'Add module',
    add_participant_club: 'Invite to my club',
    add_participant_team: 'Invite to my team',
    add_participants_club_dialog_content:
      'Do you really want to invite this group of people to your club?',
    add_participants_club_dialog_title: 'Club invitation',
    add_participants_team_dialog_content:
      'Do you really want to invite this group of people to your team',
    add_participants_team_dialog_title: 'Team invitation',
    add_to_calendar: 'Add to calendar',
    admin_dashboard: 'Admin Dashboard',
    add_event: 'Add event',
    advanced_search_screen: 'Advanced search',
    age_from: 'From',
    age_upTo: 'Up to',
    age_years: 'Years',
    age: 'Age',
    ageGroup_adult20: 'Adults over 20',
    ageGroup_adult35: 'Adults over 35',
    ageGroup_all: 'All Age Groups',
    ageGroup_baby: 'Infants',
    ageGroup_child: 'Children',
    ageGroup_schoolchild: 'School Children',
    ageGroup_senior: 'Seniors',
    ageGroup_teen: 'Juniors',
    ageGroups: 'Age Group',
    ageGroups_multi: 'Age Groups',
    all_ages: 'Every Age',
    all_chats: 'See all chats',
    all_clubs: 'All clubs',
    all_companies: 'All companies',
    all_days: 'All weekdays',
    all_events: 'All Events',
    all_gender: 'All gender',
    all_groups: 'All teams',
    all_sports: 'All sports',
    allEvents: 'All events',
    Apple_sign_in: 'Sign in with Apple',
    apply_filter: 'Apply filter',
    as_agreed: 'as agreed',
    at: 'at',
    authentication_required:
      'This page is accessible only for logged-in users. You will be redirected shortly.',
    billing_data: 'Billing data',
    birthday: 'Birthday',
    birthdaySelect: 'Select your birthday',
    block_user_description:
      "When you proceed this user will be removed from all events and teams you manage. He will not be able to find them in the search and won't be able to join them anymore.",
    block_user_revert_description:
      'When you proceed this user will again be able to find events and teams managed by you.',
    block_user_revert_title: 'Do you really revert the blocking of this user?',
    block_user_revert: 'Unblock user',
    block_user_title: 'Are you sure you want to block this user?',
    block_user: 'Block user',
    brutto_price: 'Gross price (incl. VAT) per participation in €',
    brutto_price_recurring: 'Gross price (incl. VAT) for {{count}} events in €',
    calendar_permission_settings:
      'SportJoe was not able to open your calendar due to missing permissions. Please go to the phone settings and give SportJoe access to your calendar',
    call_disabled_too_early:
      'You can start the live video broadcast 15 minutes before the event starts',
    CANCEL_EVENT: 'Cancelled the event',
    cancel: 'Cancel',
    cancelled: 'Cancelled',
    cancelEvent: 'Cancel the event',
    cancellation_policy: 'Cancellation Policy',
    cancellation_policy_link: 'Link to Cancellation Policy',
    cancel_event_dialog_content:
      'This event will be cancelled and this action cannot be reversed.',
    cancel_event_dialog_title: 'Cancel event',
    change: 'Change',
    changeColor: 'Change color',
    change_email: 'Email change',
    change_your_email: 'Change your email',
    change_your_password: 'Change your password',
    chat: 'Chat',
    chat_loading: 'Chat is loading...',
    checkbox_agree_terms:
      'tap on the checkbox to agree to the terms of use of the app.',
    choose_company: 'Choose a company',
    choose_companies: 'Choose companies',
    city: 'City',
    city_name: 'City',
    code_copied: 'Access code copied',
    companies_management: 'Companies management',
    company: 'Company',
    company_add_failure: 'Adding of company failed',
    company_add_success: 'Company added successfully',
    company_creation_failed: 'Account creation failed.',
    company_creation_failed_support:
      'Account creation failed. Please try again. If the issue persists, contact our support team for assistance.',
    company_creation_succeeded: 'invoicing details submitted successfully',
    company_manager: 'Manager',
    company_details: 'Company Details',
    company_deleting_success: 'Company deleted successfully',
    company_deleting_failure: 'Error deleting company',
    company_infos: 'Company information',
    company_infos_edit: 'Edit data',
    company_logo: 'Company logo',
    company_mail_already_exists:
      'The invoicing details with this Email already exist. Please try with a different email address',
    company_name_already_exists:
      'The invoicing details with this name already exist. Please try with a different name',
    company_update_failure: 'Error updating company data',
    company_update_success: 'Company data updated successfully',
    complete_onboarding: 'Click to complete verification',
    complete_onboarding_short: 'Complete verification',
    confirm_changes: 'Confirm changes',
    confirm_payment_description:
      'This offer is subject to a fee. The creator of this offer is responsible for pricing and execution. The stated price includes statutory VAT.',
    confirm_payment_title: 'Confirm Payment',
    choose_location: 'Please choose a location',
    choose: 'Select',
    country: 'Country',
    clone_event: 'Clone event',
    close: 'Close',
    club_detail_screen: 'Club details',
    club_join: 'Join club',
    club_leave: 'Leave club',
    club_list_screen: 'My Clubs',
    club_not_found: 'Loading the club failed. It might have gotten removed.',
    club_private_description:
      'This club can only be seen by those you share it with',
    club_private: 'Private club',
    club_share_message:
      'Hey, i found some club on SportJoe you might be interested in:\n\nTitle: {{title}}\nDescription: {{description}}\n\n{{documentUrl}}',
    club_share_title: 'Join this SportJoe club!',
    club_upcoming_screen: 'All Club-Events',
    club: 'Club',
    clubs_screen: 'Clubs',
    cockpit_label: 'Cockpit',
    cockpit_title: 'Gesundheitcockpit',
    cologne: 'Cologne',
    COMMENT_EVENT: 'Wrote a message',
    comments_screen: 'Messages',
    Comments: 'Chat',
    companies: 'Companies',
    company_sports: 'Company sports',
    company_role: 'Company role',
    company_search: 'Company search',
    company_statistics: 'Company statistics',
    confirm: 'Confirm',
    confirm_and_continue: 'Confirm and continue',
    confirmYourMail_description:
      'Please remember to confirm your email within the next 7 days. Please also check your spam folder.',
    confirmYourMail_submitButton: 'Got it',
    confirmYourMail_title: 'Confirm your E-Mail',
    continue: 'Continue',
    copyEvent: 'Copy event',
    copy_link: 'Copy link',
    create_club: 'Create club',
    create_event_description_error:
      'You need to write at least some description',
    create_event_location_error: 'Location is a mandatory field',
    create_event_title_error: 'Title',
    create_group: 'Create team',
    create_team_or_club: 'Create team or club',
    create: 'Create',
    creating_company:
      'Your invoicing details are being submitted. This may take a moment. Please do not close this window.',
    createJoeEvent: 'Create Your Sport Event',
    createOwn: 'Create your own',
    createPassword: 'Your best password',
    netto_price: 'Net price (excl. VAT) per participation in €',
    netto_price_recurring: 'Net price (excl. VAT) for {{count}} events in €',
    dark_mode: 'Dark Mode',
    data_protection: 'Data protection',
    date_placeholder: 'Pick a date',
    date_select: 'Choose date',
    date: 'Date',
    datetime: 'Date and Time',
    days: 'days',
    delete_club_dialog_content:
      'This club will be permanently deleted together with all its events and all messages.',
    delete_club_dialog_title: 'Delete club',
    delete_club: 'Delete club',
    delete_company_dialog_content:
      'This company will be removed and cannot be reverted.',
    delete_company_dialog_title: 'Delete company',
    delete_event_dialog_content:
      'This event will be removed and cannot be reverted. All participants will be notified.',
    delete_event_dialog_content_short:
      'This event will be removed and cannot be reverted.',
    delete_event_dialog_title: 'Delete event',
    DELETE_EVENT: 'Cancelled the event',
    delete_group_dialog_content:
      'This team will be removed and cannot be reverted. All public events made in this team will also be deleted.',
    delete_group_dialog_title: 'Delete team',
    delete_group: 'Delete team',
    delete_logo: 'Delete logo',
    delete_image_dialog_content: 'Are you sure you want to delete this image?',
    delete_image_multiple_dialog_content:
      'Are you sure you want to delete the images?',
    delete_image_title: 'Delete image',
    delete_image_multiple_title: 'Delete images',
    delete_message_title: 'Delete Message',
    delete_message_dialog_content:
      'Are you sure you want to delete this message?',
    delete_photo: 'Delete photo',
    delete_profile_dialog_content:
      'Are you sure to delete your account,all of your data will be deleted',
    delete_profile_dialog_title: 'Delete Account',
    delete_user_avatar: 'Delete user avatar',
    delete: 'Delete',
    deleted_user: 'Deleted user',
    description: 'Description',
    direct_chat: 'Direct Chat',
    direct_chat_with: 'Direct Chat with {{userName}}',
    direct_to_login: 'Go directly to login',
    directions: 'Get Directions',
    dismiss: 'Dismiss',
    distance: 'Distance',
    done: 'Done',
    download: 'Download',
    download_app_info_sjone: 'Download now our one - Active Team App!',
    download_app_info_sportjoe: 'Download now our SportJoe App!',
    download_app_info_part1: 'Click ',
    download_app_info_link: 'here',
    download_app_info_part2_sjone: ' and download the one - Active Team App.',
    download_app_info_part2_sportjoe: ' and download the SportJoe App.',
    edit: 'Edit',
    edit_club_screen: 'Edit club',
    edit_club: 'Edit club',
    edit_data: 'Edit data',
    edit_event_screen: 'Edit event',
    edit_event: 'Edit event',
    edit_group_screen: 'Edit team',
    edit_group: 'Edit team',
    edit_interests: 'Edit interests',
    edit_modules: 'Modules',
    editAccount: 'Edit Account',
    email_placeholder: 'example@mail.com',
    email: 'Email',
    email_address: 'Email address',
    employee: 'Employee',
    employee_confirmation_success: 'Employee confirmed successfully',
    employee_confirmation_failure: 'Failed to confirm employee',
    employee_removing_success: 'Employee removed successfully',
    employee_removing_failure: 'Failed to remove employee',
    employee_role_updating_success: 'User role updated successfully',
    employee_role_updating_failure: 'Failed  to update user role',
    employee_management: 'Employee Management',
    employee_search: 'Employee Search',
    empty_interests_screen_txt:
      'Click on the add-icon and select all the sports you are interested in.\n\nHow good are you at your sports?\nAfter choosing your sports, tap on the stars next to the type of sports to enter your level.',
    end_date: 'End date',
    end_time: 'Time until',
    english: 'English',
    error_no_loginpermission:
      'This user does not have the necessary permissions to use this app. Perhaps you do not have the required user role or your membership within your company still needs to be confirmed?',
    event: 'Event',
    event_cancel: 'Cancel',
    event_cancelled: 'Cancelled',
    event_cancelling_success: 'Event cancelled successfully',
    event_cancelling_failure: 'Canceling of event failed',
    event_count: 'Number of events',
    event_create_failure: 'Creation of event failed',
    event_create_success: 'Event created successfully',
    event_creating: 'Creating event',
    event_detail_screen: 'Sport event',
    event_detail_headline: 'Event details',
    event_details_less_than_one: 'Less than 1',
    event_deleting_success: 'Event deleted successfully',
    event_deleting_failure: 'Deleting of event failed',
    event_details: 'Event details',
    event_full: 'All spots taken',
    event_in_past: 'Sport event is in the past',
    event_joining_failure: 'Error during joining the event',
    event_joining_success: 'You have joined the event',
    event_join: 'Join Event',
    event_join_paid: 'Join - {{price}}{{currency}}',
    event_leave: 'Leave',
    event_leaving_failure: 'Leaving of event failed',
    event_leaving_success: 'You have left the event',
    event_not_found:
      'Loading the event failed because it was removed by the administrator of the event.',
    event_passed: 'Past',
    event_payment_canceled: 'Payment canceled',
    event_payment_failed: 'Payment failed',
    event_payment_success: 'Payment succeeded',
    event_prop_description_placeholder: 'Description',
    event_prop_description: 'Description',
    event_prop_title_placeholder: 'Title',
    event_prop_title: 'Title',
    event_refund_request_pending: 'Refund request sent',
    event_search: 'Event search',
    event_share_message_location: 'Location: {{location}}\n',
    event_share_message_price: 'Price: {{price}}€\n',
    event_share_message:
      'Hey, I found some sport event on Sportjoe you might be interested in:\n\nTitle: {{title}}\nSport: {{sport}} {{eventType}}\nDate: {{dateString}} at {{timeString}}\n{{location}}Description: {{description}}\n{{price}}\n\n{{documentUrl}}',
    event_type: 'Event Type',
    event_update_failure: 'Updating of event failed',
    event_update_success: 'Event updated successfully',
    event_updating: 'Updating event',
    eventName: 'Event name',
    events_screen: 'Events',
    events_search_clicked: 'Enter a keyword to search for matching events',
    events: 'Events',
    eventType: 'My/All Events',
    every: 'Every',
    everyday: 'Every day',
    everyDays: 'Every {{days}} day',
    everyone_already_part_off_team:
      'Everyone in the group of people you want to invite are already part of the club',
    facebook_sign_in: 'Sign in with Facebook',
    feedback_prop_body_placeholder: 'Write your feedback here',
    feedback_prop_body: 'Feedback',
    feedback_prop_subject_placeholder: 'Provide a subject',
    feedback_prop_subject: 'Subject',
    feedback_screen: 'Feedback',
    feedback_send_failure: 'Error when sending feedback',
    feedback_send_success: 'We got your feedback. Thanks!',
    feedback_sending: 'Sending feedback...',
    feedback: 'Send feedback',
    fee: 'Platform fee:',
    FEMALE: 'Female',
    file_size_error:
      'File is too large (maximum size is {{maxSize}} {{unit}}).',
    filterAnyTime: 'Any Time',
    filterEvening: '6 pm - 12 pm',
    filterMapPickError:
      'Fetching the position failed, please pick one manually',
    filterMorning: '6 am - 12 am',
    filterNew: 'Filter',
    filterNextWeek: 'Next Week',
    filterNoon: '12 am - 6 pm',
    filterPickLocation: 'Pick Location',
    filterThisWeek: 'This Week',
    filterToday: 'Today',
    filterTomorrow: 'Tomorrow',
    findable_description_false:
      'In the public search, I am only shown people who are in a club or event with me.',
    findable_description_true: 'Everyone can find me in public search.',
    findable_title: 'Other users can find me',
    find_us_on: 'Find us on: ',
    for_online_event: 'for online events',
    for_non_online_event: 'for non-online events',
    for_recurring_events: 'for a series of events',
    forgot_password_description:
      "Enter your email address and we'll send you instructions on how to recover your account",
    forgot_password_failure: 'Error when starting password-reset process',
    forgot_password_in_progress: 'Requesting new password...',
    forgot_password_navtitle: 'Forgot password',
    forgot_password_request_failure: 'Requesting new password failed!',
    forgot_password_send: 'Send',
    forgot_password_success: 'Request sent, please check your email',
    forgot_password_title: 'Get a new password',
    forgotPassword: 'Forgot password',
    free_events: 'Free Events',
    full_address: 'Full address',
    fullName: 'Full name',
    gender_select: 'Choose a gender',
    gender: 'Gender',
    german: 'German',
    germany: 'Germany',
    go_to_call: 'Start live video broadcast',
    go_to_event: 'Go to event',
    google_sign_in: 'Sign in with Google',
    group_count: 'Number of teams',
    group_create_failure: 'Creation of team failed',
    group_deleting_success: 'Team deleted successfully',
    group_deleting_failure: 'Deleting of team failed',
    group_detail_event_list_events_title: 'Events',
    group_detail_event_list_plus_event: 'Event',
    group_detail_screen: 'Team details',
    group_details: 'Team details',
    group_join: 'Join team',
    group_joining_failure: 'Error during joining the team',
    group_joining_success: 'You have joined the team',
    group_image: 'team image',
    group_leave: 'Leave team',
    group_leaving_failure: 'Leaving of team failed',
    group_leaving_success: 'You have left the team',
    group_list_screen: 'My Clubs',
    group_member: 'Member',
    group_members: 'Members',
    group_create_success: 'Group created successfully',
    group_not_found: 'Loading the team failed. It might have gotten removed.',
    group_photo: 'Team photo',
    group_private_description:
      'This team can only be seen by those you share it with',
    group_private: 'Private Team',
    group_public: 'Public Team',
    group_prop_description: 'Description',
    group_prop_title: 'Title',
    group_share_message:
      'Hey, i found some team on SportJoe you might be interested in:\n\nTitle: {{title}}\nDescription: {{description}}\n\n{{documentUrl}}',
    group_share_title: 'Join this SportJoe Team!',
    group_upcoming_screen: 'All Team-Events',
    group_update_failure: 'Updating of team failed',
    group_update_success: 'Team updated successfully',
    group: 'Team',
    groups_screen: 'Teams',
    group_search: 'Team search',
    groups: 'Teams',
    history: 'Show past events',
    heading_error: 'Oops... Something went wrong.',
    health_on_demand: 'Health OnDemand',
    hide_access_codes: 'Hide access codes',
    hide_registration_details: 'Hide employee registration details',
    homepage_redirect_message: 'You will be redirected to the home page.',
    hometown: 'Hometown',
    homeTown: 'Hometown',
    hosted_by: 'Hosted by',
    hosted_for: 'Hosted for',
    iAgreeWith: 'I agree with the',
    identifier: 'identifier',
    image_message_text: 'Photo',
    imprint: 'Legal information',
    imprint_link: 'Link to legal information',
    interest_advanced: 'Advanced',
    interest_beginner: 'Beginner',
    interest_description:
      'Select one to three stars to indicate your level of performance.',
    interest_newbie: 'First Try',
    interest_normal: 'Intermediate',
    interest_pro: 'Pro',
    interests_details:
      'Select one to five stars to indicate your level of performance',
    interests_picker: 'Type of sports',
    interests_saved_failure: 'Updating of user interests failed',
    interests_saved_success: 'Your interests have been successfully saved',
    interests_screen: 'Interests screen',
    interest: 'Interest',
    interests: 'Interests',
    interestsNotSpecified: 'Interest not specified',
    invitation_sent: 'Your invitation was sent',
    invite_member_club: 'Invite to club',
    invite_member: 'Invite to team',
    invite: 'Invite a friend',
    invoicing_details: 'Invoicing Details',
    JOIN_EVENT: 'Joined the event',
    join_event_to_see_chat: 'Join event to see the conversation',
    join_group_to_see_chat: 'Join group to see the conversation',
    join_team_to_create_events: 'Join the team to create events',
    join: 'Join',
    joined: 'Joined',
    just_now: 'A few seconds ago',
    label: 'Label',
    label_company: 'Label',
    label_de: 'German Label',
    label_en: 'English Label',
    labelMissing: 'Label missing',
    language: 'Language',
    lbl_description: 'Description',
    lbl_legalinformation: 'Legal information',
    lbl_loading: 'Loading...',
    lbl_privacypolicy: 'Data protection',
    lbl_taptochangecolor: 'Tap to change color',
    LEAVE_EVENT: 'Left the event',
    legal_screen: 'Legal',
    level_screen: 'Sports',
    link_copied: 'Link copied',
    link_or_contact_with_sj:
      'Link to your website or get in touch with SportJoe',
    loading_address: 'Loading address...',
    loading_images: 'Loading images',
    loading_image: 'Loading image',
    loading_medium: 'Loading medium',
    loading_media: 'Loading media',
    location_add_success: 'Location added successfully',
    location_add_failure: 'Adding of location failed',
    location_image: 'Location image',
    location_management: 'Location management',
    location_name: 'Location name',
    location_picker_noPermissionMessage:
      'To use your position as location we have to now your current location. Without this permission you have to search your location manually.',
    location_picker_screen: 'Select location',
    location: 'Location',
    locationForbidden:
      'You have forbidden SportJoe to access your location. To use this feature, you need to allow SportJoe to determine your location in your phone settings.',
    login_failure: "Something went wrong, we're fixing it, please check later",
    login_success: 'Login successful',
    login: 'Login',
    loginCheckToActivate: 'Check your email to activate account',
    loginFinalizeLogin:
      'To complete registration we just need some more information about you',
    loginNoUserWithCredentials: 'No user with these credentials',
    loginSocialAccount: 'This account was registered with social login',
    logo_upload: 'Logo upload',
    logo_uploaded: 'Logo uploaded',
    logout: 'Logout',
    MALE: 'Male',
    manage_modules: 'Manage modules',
    map_filter_screen: 'Search area',
    max_participants: 'Maximum participants',
    max_file_upload_limit: 'You can upload a maximum of {{count}} files',
    member_count: '{{count}} members',
    member_long: 'You are member of the team',
    members: 'Members',
    members_screen_none: 'No members yet',
    members_screen_plural: '{{count}} Members:',

    members_screen_singular: '{{count}} Member:',
    message: 'Message',
    min_text_length_error:
      '{{the_field_name}} must be at least {{min_length}} characters long',
    minimal_interests_toast: 'Select at least one type of sports',
    minimumLengthRequired: 'Minimum 8 characters required',
    missing_label: 'Everywhere',
    module_picture: 'Module picture',
    modules_set_success: 'Modules set successfully',
    modules_set_failure: 'Error setting modules',
    modules: 'Health Modules',
    more_comments: 'more messages',
    more_interest: 'more interest',
    more_interests: 'more interests',
    more_options: 'More options',
    more: 'More',
    msg_addComment: 'Add a message',
    msg_allFieldsRequired: 'Please fill out all the fields',
    msg_authFailed: 'Authentication failed. Please try again!',
    msg_checkMail: 'Please check your email',
    msg_checkMailforActivation:
      'Please check your email to activate your SportJoe account.\nNo email? Check your spam folder',
    msg_checkYourLocation:
      'Check your location.\n\nIf everything fits there is no sport event in your area.\n\nClick on the magnifying glass and change the search options or',
    msg_chooseTitleAndDescription: 'Choose title and description',
    msg_connectAccountHint:
      "An Account with this email is already existing. Sign in with it's password to connect your {{ssoProvider}}-Account with it.",
    msg_emailRequired: 'Please enter a valid email address',
    msg_errorOccurred: 'there was an error',
    msg_fillTheFields: 'Enter your credentials first',
    msg_joined_event: 'Joined the event',
    msg_left_event: 'Left the event',
    msg_messageSend: 'Message was successfully sent',
    msg_minFullName: 'Minimum 2 characters required',
    msg_noEmailMatch:
      "The email address that you've entered doesn't match any account.",
    msg_noInternetConnection: 'No internet connection',
    msg_noInternetConnectionDescription:
      "You need an internet connection to use the app. Currently you don't seem to have a connection, please check your internet settings and try again.",
    msg_pastTime: 'Past time',
    msg_selectFutureTime: 'Please select the time in the future',
    msg_shareSportjoeMsg:
      "Hey! I'm already part of the SportJoe community. Try out the SportJoe app to find sportpartners and events in your area! \n\nDownload the app here:\n ",
    msg_shareSportjoeTitle: 'I invite you to SportJoe',
    msg_somethingWrong: 'Something went wrong sorry',
    msg_storeProfileError: 'There was an error updating the profile',
    msg_updated_event: 'Updated the event',
    msg_updateSuccessful: 'Successful update',
    msg_useraccount_banned: 'This account has been banned due to misbehaviour',
    msg_youSeeNoEvents: "You don't see any Sport events?",
    my_club_list_empty:
      'You are not yet a member of a club in the app. Join a club by searching for it. If you are a special user want to create a new club yourself, click on the round icon at the bottom right.',
    my_clubs: 'My clubs',
    my_group_list_empty:
      "You haven't created a club yet. Click on the round icon on the bottom right and create a club.",
    my_all_groups: 'My/All Teams',
    my_events: 'My Events',
    my_past_events: 'My past events',
    my_teams: 'My teams',
    my_groups: 'My Teams',
    myEvents: 'My events',
    my_interests: 'My interests',
    my_stripe_account: 'My Stripe Account',
    NA: 'N/A',
    name_placeholder: 'Your name',
    name: 'Name',
    Name: 'Name',
    new_club_screen: 'New Club',
    new_event: 'New Event',
    new_event_screen: 'New Sport Event',
    new_filter: 'New filter',
    new_group: 'New Team',
    new_group_button: 'New Team',
    new_group_screen: 'New Team',
    new_mail: 'New Email',
    new_team_or_club_screen: 'New Team/New club',
    new_password: 'Password change',
    newPassword: 'Get a new password',
    next_event: 'Next event',
    no_address_in_invoice_needed: 'Choose invoice without address',
    no_club: 'No Club',
    no_comments_yet: 'No messages yet.',
    no_comments: 'No messages...',
    no_events: 'No events yet',
    no_events_in_area: 'There are no events in your area.',
    no_group: 'No Team',
    no_interests_selected: 'No interests selected',
    no_modules: 'You have no available modules',
    no_options: 'No matches found',
    no_past_events: 'No past events',
    No_person: 'No one',
    No: 'No',
    noCalendarPermission: 'No permission to access calendar',
    noCameraPermission:
      'To use this feature, we need access to the camera. Please grant us this permission in the app settings.',
    no_chats: 'No chats available',
    noClubs: "You don't see any clubs?",
    noClubsHint:
      'Check your location.\nIf everything fits there is no club nearby.',
    no_companies_trainer: 'You haven',
    noEvents: "You don't see any Sport events?",
    noEventsFiltered: 'No sport event found for your search criteria',
    noEventsHint:
      'Check your location.\nIf everything fits there is no sport event nearby.',
    noInternet: 'No Internet Connection',
    noLocationEnabled:
      'In order to use this function we need your location. Please activate your location sensor.',
    noLocationPermission:
      'To be able to use this function, we need your location. Please grant us this right in the settings of the app.',
    noLocationsFiltered: 'No locations in your search criteria',
    no_permission: "Unfortunately, you don't have access to this page.",
    noSportsFiltered:
      'This sport is not yet in our app. \nTry it under "Other sport"',
    noStoragePermission:
      'To use this feature, we need access to the storage. Please grant us this permission in the app settings.',
    notifications_request: 'May we send you push notifications?',
    noTeams: "You don't see any clubs?",
    noTeamsHint:
      'Check your location.\nIf everything fits there is no club nearby.',
    noUpcoming: 'No upcoming events',
    noUsers: 'There are no matches for your search criteria',
    noUsersHint: 'Try other filters to get more results',
    NTF_AAA_NOTIFICATION_CONSTANTS:
      'following messages are translations for predefined constant messages by server:',
    NTF_CANCEL_EVENT: '{{name}} cancelled the event',
    NTF_CLUB_COMMENT: '{{name}} wrote a message in the club',
    NTF_CLUB_CREATED: "The club '{{name}} is now at SportInKöln",
    NTF_CLUB_DELETE: '{{name}} deleted the club',
    NTF_CLUB_JOIN: '{{name}} joined the club',
    NTF_CLUB_LEAVE: '{{name}} left the club',
    NTF_CLUB_UPDATE: '{{name}} updated the club',
    NTF_COMMENT_CLUB: '{{name}} wrote a message in the club',
    NTF_COMMENT_EVENT: 'wrote a message in the event',
    NTF_COMMENT_GROUP: '{{name}} wrote a message in the team',
    NTF_COMMENT_TITLE: 'New message',
    NTF_COMMENT: '{{name}} has written a new message',
    NTF_DELETE_CLUB: '{{name}} deleted the club',
    NTF_DELETE_EVENT: '{{name}} deleted the event',
    NTF_DELETE_GROUP: '{{name}} deleted the team',
    NTF_EVENT_CANCEL: '{{name}} cancelled the event',
    NTF_EVENT_COMMENT: '{{name}} wrote a message in the event',
    NTF_EVENT_CREATED: "The event '{{name}}' was created",
    NTF_EVENT_DELETE: '{{name}} deleted the event',
    NTF_EVENT_JOIN: '{{name}} joined the event',
    NTF_EVENT_LEAVE: '{{name}} left the event',
    NTF_EVENT_UPDATE: '{{name}} updated the event',
    NTF_GROUP_COMMENT: '{{name}} wrote a message in the team',
    NTF_GROUP_CREATED: "The team '{{name}}' was created",
    NTF_GROUP_DELETE: '{{name}} deleted the team',
    NTF_GROUP_JOIN: '{{name}} joined the team',
    NTF_GROUP_LEAVE: '{{name}} left the team',
    NTF_GROUP_UPDATE: '{{name}} updated the team',
    NTF_JOIN_CLUB: '{{name}} joined the club',
    NTF_JOIN_EVENT: '{{name}} joined the event',
    NTF_JOIN_GROUP: '{{name}} joined the team',
    NTF_LEAVE_CLUB: '{{name}} left the club',
    NTF_LEAVE_EVENT: '{{name}} left the event',
    NTF_LEAVE_GROUP: '{{name}} left the team',
    NTF_MESSAGE_DELETED: 'This message has been deleted',
    NTF_UPDATE_CLUB: '{{name}} updated the club',
    NTF_UPDATE_EVENT: '{{name}} updated the event',
    NTF_UPDATE_GROUP: '{{name}} updated the team',
    numberRangeFilter_maxLowerThanMin:
      'The first value must be smaller than the second.',
    numberRangeFilter_notAnInt:
      "Congratulations, you found a bug in SportJoe! It's great that you somehow managed to write something in here that isn't a whole number, but unfortunately we can't handle it either. Because we always want to improve SportJoe, it would be great if you could tell us how you managed to trigger this bug. You can easily report this and other bugs to us at {{profile_screen}}→{feedback}}.",
    numberRangeFilter_valueGreaterThanMax:
      'Only values up to {{maxValue}} are allowed.',
    numberRangeFilter_valueLowerThanMin:
      'Only values from {{minValue}} are allowed.',
    offline: 'offline',
    of_company: 'of {{companyName}}',
    of_provider: 'of provider',
    ofSportJoe: 'of SportJoe',
    on_demand: 'On Demand',
    on_demand_link: 'The link to the on demand event',
    one_description:
      'Sports opportunities and health services for trainers and organizations',
    one_week_ago: 'One week ago',
    online_event_description:
      'Offer your event online via live video chat. When activated, a link for the online event will be displayed in the event details.',
    online_event: 'Online Event',
    online: 'online',
    online_and_offline: 'Online & Offline',
    online_big: 'Online',
    online_upper: 'ONLINE EVENT',
    open_chats: 'Open chats',
    open_company: 'Open Company',
    open_event: 'Open Event',
    open_group: 'Open Team',
    open_settings: 'Open settings',
    open_user_settings: 'Open user settings',
    optimal_dimensions:
      'Optimal dimensions: {{width}}:{{height}} (width x height)',
    optional: 'Optional',
    options: 'Options',
    or: 'or',
    order_summary: 'Summary of Your order',
    OTHER: 'Diverse',
    our: 'Our',
    owner_imprint: 'Legal information of',
    paid: 'Paid Event',
    paid_event: 'Paid Event',
    paid_events: 'Paid Events',
    paid_offers:
      'When making a chargeable offer, remember to add your mandatory information (e.g. according to §5a Abs. 3 UWG and §5 TMG). Please write the word [advertisement] before the beginning of your text',
    page_not_available: 'Page not available',
    participant_detail_screen: 'Participant details',
    participant_details_title: 'Participant Details',
    participants_screen: 'Participants',
    participants_number: 'Number of Participants',
    participants_screen_none: 'No participants yet',
    participants_screen_singular: '{{count}} Participant:',
    participants_screen_plural: '{{count}} Participants:',
    participants_screen_plural_with_limit:
      '{{count}} of {{limit}} Participants:',
    participating: "You're participating!",
    participating_long: 'You are participating in the event!',
    partners: 'Our partners',
    passedEvents: 'Passed Events',
    password_placeholder: '********',
    password: 'Password',
    past_event: 'Past',
    pay_and_order: 'Pay & Order',
    payment_type: 'Payment',
    payout_per_participant: 'Payout amount for you',
    pending_invite: 'You have been invited to join this room',
    pending_knock: 'You asked to be invited to join this room',
    people_going: 'people going',
    peopleInterestedIn: 'For people interested in',
    permission_calendar_message:
      'In order to enter the date and time of this event into your calendar we need permission to access it.',
    permission_calendar_title: 'Why do we need access to your calendar?',
    permission_camera_message:
      'To give you the opportunity to use the camera and take a photo.',
    permission_camera_title: 'What we need your camera for?',
    permission_location_message:
      'To show you sport events in your area we have to now your current location. Otherwise the search will not work.',
    permission_location_title: 'What do we need your location for?',
    permission_microphone_message:
      'We want to transmit your voice during the video call.',
    permission_microphone_title:
      'SportJoe app would like to access your microphone',
    permission_storage_message:
      'To give you the opportunity to choose a picture from your phone.',
    permission_storage_title: 'What we need storage permission for?',
    pick_time: 'Pick time',
    picker_screen: 'Select type of sports',
    pickTime: 'Pick a time',
    phoneNumber: 'Phone number',
    plus_more_count: ' (+{{count}} more)',
    postal_code: 'Postal Code',
    photo_uploaded: 'Photo uploaded',
    price: 'Price',
    privacy_policy: 'Privacy Policy',
    privacy_screen: 'Privacy',
    privacy: 'Privacy',
    private_description:
      'This event can only be seen by those you share it with',
    private_title: 'Private Event',
    private: 'Private',
    proceed_to_payment: 'Proceed to payment',
    pay_now: '{{price}} Place a binding order now',
    profile_choose_image: 'Select a photo',
    profile_delete_account: 'Do you really wanna delete your account?',
    profile_delete_image: 'Delete the image and use initials',
    profile_screen: 'Profile',
    profile_take_image: 'Take a photo',
    profile_update_failure: 'Error updating profile',
    profile_update_success: 'Success updating profile',
    profile_updating: 'Updating profile...',
    prop_user_color_placeholder: 'Choose a color',
    prop_user_color: 'User color',
    prop_user_description_placeholder: 'Introduce yourself shortly',
    prop_user_description: 'Description',
    prop_user_gender_placeholder: 'Tell us about your gender',
    prop_user_gender: 'Gender',
    prop_user_name_placeholder: 'Provide your username',
    prop_user_name: 'Name',
    public_clubs: 'Public Clubs',
    public_event: 'Public Event',
    public_groups: 'Public Teams',
    quote: 'Quote',
    recurring_description:
      'Check this in order to mark an event as being repeated weekly.',
    recurring_end_before_start_error:
      'The end date must be after the start date',
    recurring_title: 'Recurring event',
    recurring_weekly: 'Weekly',
    recurring_weekly_short: 'wkly',
    recurring: 'Recurring',
    reject_invite: 'Reject Invite',
    register_failure_email_used: 'This Email is already used',
    register_failure: 'Registration failed',
    register_in_progress: 'Registering...',
    register: 'Register',
    registration_details: 'Registration details',
    registration_link: 'Registration link',
    reload_events: 'Reload events',
    reload_groups: 'Reload teams',
    reminder_description_hometown:
      'Enter your hometown now. Sports enthusiasts who live close to you can find you more easily.',
    reminder_description_sports:
      'Enter your favorite sports now. People who share your passion can find you more easily.',
    reminder_later: 'Later',
    reminder_never: "Don't ask again",
    reminder_now: 'Enter now',
    reminder_title: 'Your profile is still incomplete',
    remove_club: 'Delete club',
    remove_event: 'Delete event',
    remove_employee: 'Remove employee',
    remove_employee_dialog_title: 'Remove employee',
    remove_employee_dialog_content:
      'This employee will be removed from the company.',
    remove_group: 'Delete team',
    request_refund: 'Request a refund',
    request_refund_description:
      'If you confirm, we will send a refund request to the event organizer. However, whether you receive the money depends on whether you met the refund deadline of the event organizer.',
    request_refund_message:
      'Hi, I wanted to request a refund for the event {{eventName}}. {{name}}, {{email}}.',
    report_club_screen: 'Report club',
    report_club: 'Report club',
    report_event_screen: 'Report event',
    report_event: 'Report event',
    report_prop_body_placeholder:
      'State here why you report {{the_reportedObjectType}}',
    report_prop_body_user: 'What did {{reportedObject}} wrong?',
    report_prop_body: 'What happened wrong in {{reportedObject}}?',
    report_send_failure: "Report couldn't be send",
    report_send_success: '{{reportedObjectName}} is now reported',
    report_team_screen: 'Report team',
    report_team: 'Report team',
    report_user_screen: 'Report user',
    report_user: 'Report user',
    reset: 'reset',
    reset_filter: 'Reset filter',
    resilience: 'Resilience',
    return_to_homepage: 'Return to homepage',
    role_change_confirmation_text:
      'Should the user role be changed to {{role}}?',
    role_change_confirmation_title: 'Confirm changes',
    safari_matrix_info:
      'Chat is currently unavailable in Safari. Please switch to a different browser to continue.',
    saw_all_events:
      'You have seen all the events. Try adjusting your filter criteria to discover more events.',
    saw_all_events_on_demand:
      'You have seen all the on demand events. Try adjusting your filter criteria to discover more on demand events.',
    saw_all_groups:
      'You have seen all teams. Try adjusting your filter criteria to discover more teams.',
    save: 'Save',
    screen_back: 'Back',
    search_area: 'Search area',
    search_area_km: 'Search area in Kilometers',
    search_events: 'Search for events',
    search_user: 'Search user',
    search_teams: 'Search for teams',
    search: 'Search',
    searchSports: 'Filter for a sport',
    see_all_comments: 'See all messages',
    see_all_events: 'See all events',
    see_all: 'See all',
    see_club_details: 'Go to club',
    see_group_details: 'Go to team',
    see_more: 'See more',
    see_on_the_map: 'See on the map',
    select_club: 'Select club',
    select_group: 'Select team',
    select_location: 'Select location',
    send: 'Send',
    sendingFeedback: 'Feedback is being sent...',
    settings: 'Settings',
    share_club: 'Share club',
    share_group: 'Share team',
    share: 'Share event',
    share_message: 'Just found this on #{{appVariant}}. What do you think?',
    share_message_with_url:
      'Just found this on #{{appVariant}}. What do you think?\n\n{{url}}',
    share_sj: 'SportJoe event',
    share_with: 'Share with {{platform}}',
    show_access_codes: 'Show access codes',
    show_more_interests: 'more',
    show_all_events: 'Show all events',
    show_all_groups: 'Show all teams',
    show_company_events: 'Show company events',
    show_company_groups: 'Show company teams',
    show_registration_details: 'Show employee registration details',
    showList: 'Show List',
    showMap: 'Show Map',
    show_default_photo: 'Show default photo',
    showTermsRequiredHint: 'Mandatory',
    signIn: 'Sign In',
    signUp: 'Sign Up',
    socialSignUp: 'One last step',
    sport_select: 'Select sport',
    sport: 'Sport',
    sport_discipline: 'Sport discipline',
    sports_community: 'Your SportsCommunity',
    sports_picker_screen: ' Sports picker screen',
    sports_selected_count: '{{count}} selected sports',
    spouse: 'Spouse',
    subject: 'Subject',
    submit_payment: 'Pay {{price}}€',
    start_time: 'Time from',
    street: 'Street',
    street_number: 'Street number',
    stripe_account_no_company:
      ' Please provide us with the invoicing details to create paid events.',
    stripe_account_not_verified:
      'Your Stripe account is not verified. Please verify your account to create paid events.',
    stripe_account_not_verified_no_company:
      'Your Stripe account is not verified. Please verify your account and provide us with the invoicing details to create paid events.',
    stripe_fee_info: 'Payment provider: From 1.5% + €0.25',
    stripe_onboarding_app_tag_info:
      'In order to create a paid event, visit our website ',
    stripe_onboarding_info:
      'Your Stripe account is being set up. You will be redirected shortly.',
    submit: 'Submit',
    subscription_choice: 'Issue Selection',
    subscription_mh: "I would like to receive two free Men's Health issues",
    subscription_no: 'I do not want to receive any free issues.',
    subscription_wh: "I would like to receive two free Women's Health issues",
    supported_payment_methods: 'Supported payment methods:',
    team_choose_image: 'Select an image',
    team_delete_image: 'Delete the image',
    teams: 'Teams',
    teams_and_clubs_screen: 'Clubs & Teams',
    telsYou: 'tells you why we need your information.',
    terms_and_conditions: 'Terms and conditions',
    terms_and_conditions_sj: 'Terms and conditions Sportjoe GmbH',
    terms_of_participation: 'Terms of participation',
    terms_of_use: 'Terms of use',
    terms_of_participation_link: 'Link to your terms of participation',
    the_cancellation_policy: 'the cancellation policy',
    the_terms_of_use: 'the terms of use',
    the_terms_of_participation: 'the terms of participation',
    thanksForFeedback: 'Thanks for your feedback',
    the_club: 'the club',
    the_event: 'the event',
    the_interests_levels: 'Level',
    the_interests: 'Sports',
    the_login: 'Login',
    the_subject: 'The subject',
    the_team: 'the club',
    the_title: 'The title',
    the_user: 'the user',
    time_from_miniscule: 'from',
    time_from: 'From',
    time_oClock: "o'clock",
    time_placeholder: 'Pick a time',
    time_select: 'Choose time',
    time_upTo: 'Up to',
    time: 'Time',
    title_Add_members_club: 'Invite to my club',
    title_Add_members_group: 'Invite to my team',
    title: 'Title',
    to_connectAndLogin: 'Connect and sign in',
    today: 'Today',
    to_filter: '{{documentType}} filter',
    to_login: 'Login',
    to_requestConfirmationEmail: 'Resend confirmation email',
    to_select: 'Select',
    trainer: 'Trainer',
    trainer_event: 'Trainer Event',
    trainer_group: 'Trainer Team',
    trainer_welcome_text:
      'Dear Trainer,\n\nOn this platform, you can create offers related to health prevention. Only employees of companies that invited you to register can participate in your offers. You can create location- and time-bound appointments under the "Events" tab. Use the "Teams" tab to add groups and get in touch with interested participants. The "Chats" tab provides an overview of all group and individual chats.\n\nHave fun using one - Active Team!',
    unblock_user: 'Unblock user',
    understood: 'Understood',
    unlimited: 'Unlimited',
    until: 'until',
    unread_event: '{{count}} unread message',
    unread_events: '{{count}} unread messages',
    unread_events_count: 'New chat messages',
    upcoming_events_screen: 'My Events',
    UPDATE_EVENT: 'Updated the event',
    update_company_data: 'Update company data',
    update_event: 'Update event',
    update_group: 'Update team',
    update_interests: 'Update interests',
    update_user_data: 'Update user data',
    update: 'Update',
    updateClub: 'Update club',
    updateGroup: 'Update team',
    updateProfile: 'Update profile',
    upload_logo: 'Upload logo',
    upload_media: 'Upload media',
    upload_photo: 'Upload photo',
    upload_user_avatar: 'Upload user avatar',
    url: 'URL',
    use19vat: 'Do the events you organize incur the 19% VAT?',
    use19vat_info: 'Information about VAT',
    user_avatar: 'User avatar',
    user_confirmed: 'Confirmed',
    user_deleted: 'User is deleted',
    user_interests_not_selected: 'User did not choose his interests',
    user_no_interests: 'User did not choose his interests',
    user: 'SportJoe User',
    user_blocked: 'User is blocked',
    user_count: 'Number of users',
    userName: 'User name',
    user_not_authenticated: 'You are not authenticated',
    user_owns_paid_events:
      'You have created paid events that have not yet taken place. Therefore, deleting your profile is not possible.',
    user_profile: 'User Profile',
    user_role: 'User Role',
    user_informations: 'User informations',
    user_infos_update_success: 'User informations updated successfully',
    user_infos_update_failure: 'Updating of user informations failed',
    user_settings: 'User Settings',
    validation_allrequired: 'Please fill all fields.',
    validation_birthdate_minimumAge:
      'The minimum age to use this feature is {{minimumAge}}',
    validation_invalid: 'Invalid value for {{fieldName}}',
    validation_required: '{{fieldName}} is a mandatory parameter',
    validation_title_less_2: 'The title must be at least 3 characters',
    video_message_text: 'Video',
    wait_progress: 'Please wait...',
    website: 'Website',
    weekday_notSelectedError: 'Select at least one day of the week',
    weekdayAll: 'All Days',
    weekdayFriday_short: 'Fri',
    weekdayFriday: 'Fridays',
    weekdayMonday_short: 'Mon',
    weekdayMonday: 'Mondays',
    weekdaySaturday_short: 'Sat',
    weekdaySaturday: 'Saturdays',
    weekdaySunday_short: 'Sun',
    weekdaySunday: 'Sundays',
    weekdayThursday_short: 'Thu',
    weekdayThursday: 'Thursdays',
    weekdayTuesday_short: 'Tue',
    weekdayTuesday: 'Tuesdays',
    weekdayWednesday_short: 'Wed',
    weekdayWednesday: 'Wednesdays',
    weekdays: 'Weekdays',
    whereAreYouLooking: 'Search here',
    welcome: 'Welcome',
    welcome_text: 'Welcome text',
    writeComment: 'Write your message',
    writeFeedback: 'Write your feedback here',
    writeSubject: 'Subject',
    wrong_credentials: 'Wrong credentials',
    year_abbr: 'Y',
    yearOfBirth: 'Year of birth',
    Yes: 'Yes',
    yesterday: 'Yesterday',
    you: 'You',
    your_companies: 'Your companies:',
    your_full_name: 'Your full name',
    your_logo: 'Your company logo',
    your_name: 'Your name',
    your_password: 'Your password',
    your_position: 'Your position',
    yourProfileForOthers_description:
      'Search and find new sport partners, clubs and sporting events. You decide what we show others about you.',
    yourProfileForOthers_title: 'Visibility Of Your Profile For Others'
  },
  validation: {
    address_invalid: 'Please choose a valid address.',
    email_invalid: 'Please enter a valid email address.',
    end_date_cannot_be_before_start_date: 'End date must be before start date.',
    end_time_cannot_be_before_start_time:
      'The end time cannot be before the start time.',
    end_date_must_be_after_start_date:
      'End date must be at least {{days}} days after the start date',
    phone_invalid: 'Please enter a valid phone number.',
    website_invalid: 'Please enter a valid website starting with "https',
    url_invalid: 'Please enter a valid URL starting with "https".',
    is_required: '{{name}} is required.',
    max_length: '{{name}} should be at most {{max}} characters.',
    min_length: '{{name}} must be at least {{min}} characters long.',
    min_value: '{{name}} must be at least {{min}}.',
    min_age: 'The user must be at least {{age}} years old.',
    max_age: 'The user must be at most {{age}} years old',
    invalid_participants:
      'The maximum number of participants must be a number or "unlimited".',
    less_than_current:
      'The maximum number of participants cannot be less than the current number of participants.',
    time_in_past: 'The chosen time cannot be in the past.',
    cancellation_policy_must_be_accepted:
      'The cancellation policy must be accepted',
    terms_of_participation_must_be_accepted:
      'The terms of participation must be accepted',
    terms_of_use_must_be_accepted: 'The terms of use must be accepted',

    date_in_past: 'The chosen date cannot be in the past.',
    weekday_notSelectedError: 'Select at least one day of the week'
  },

  navigation: {},
  example: {
    card_title: 'A title',
    card_subtitle: 'A subtitle',
    card_text: 'This is a text in a card component',
    card_input_title: 'Some input elements',
    input_text: 'Text Input',
    input_search_placeholder: 'Search'
  },

  system_messages: {
    room_joined: '{{user}} has joined the room',
    room_left: '{{user}} has left the room',
    room_created: 'Room created',
    event_cancelled: '{{user}} has cancelled the event',
    event_edited: '{{user}} has edited the event',
    group_edited: '{{user}} has edited the team',
    knocked: 'Waiting for invite',
    invited: 'Invited',
    member_invited: '{{user}} has been invited',
    namechange: "{{oldName}} changes name to '{{newName}}'",
    invite_rejected: '{{user}} has rejected the invite',
    room_metadata: 'Admin modified this rooms data',
    redacted: 'Message has been deleted'
  },

  health_modules: {
    open_module: 'Open Module',
    module: {
      covital: 'CoVital',
      entspannung: 'Relaxation',
      ernaehrung: 'Nutrition',
      konsum: 'Consume',
      medialib: 'Media',
      schlaf: 'Sleeping',
      sport_und_bewegung: 'Sport & Movement',
      ['entspannung-test']: 'Relaxation',
      ['ernaehrung-test']: 'Nutrition',
      ['konsum-test']: 'Consume',
      ['medialib-test']: 'Media',
      ['schlaf-test']: 'Sleeping',
      ['sport_und_bewegung-test']: 'Sport & Movement'
    },
    complete_sleep_survey: 'Complete Survey',
    cockpit_home: 'Health cockpit'
  }
};
